import { render, staticRenderFns } from "./DoctorConceptSection.vue?vue&type=template&id=33486ed7"
import script from "./DoctorConceptSection.vue?vue&type=script&lang=js"
export * from "./DoctorConceptSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports